import {
  AllEnterpriseModule,
  type CellClickedEvent,
  type ColDef,
  type GridApi,
  type GridOptions,
  LicenseManager,
  ModuleRegistry,
} from "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";
import { type FC, type Ref, useCallback, useImperativeHandle, useMemo, useRef } from "react";

import { VStack } from "../Stack/VStack.js";
import { themeSelector } from "./theme.js";

LicenseManager.setLicenseKey(
  "Using_this_{AG_Grid}_Enterprise_key_{AG-062571}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Genedata_AG}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Genedata_Selector}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Genedata_Selector}_need_to_be_licensed___{Genedata_Selector}_has_been_granted_a_Deployment_License_Add-on_for_{35}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{30_August_2025}____[v3]_[01]_MTc1NjUwODQwMDAwMA==200708ce68246611fb1ed9391f4da819",
);

// Register all Community features
// @see https://www.ag-grid.com/react-data-grid/modules/ to reduce size
ModuleRegistry.registerModules([AllEnterpriseModule]);

export interface ClientGridProps
  extends Pick<
    GridOptions,
    | "columnDefs"
    | "rowData"
    | "rowSelection"
    | "onCellClicked"
    | "defaultColDef"
    | "autoGroupColumnDef"
    | "onGridReady"
    | "onSelectionChanged"
    | "onSortChanged"
  > {
  gridApi?: Ref<Partial<GridApi> | undefined>;
}

export const ClientGrid: FC<ClientGridProps> = (props) => {
  const gridRef = useRef<AgGridReact>(null);

  useImperativeHandle(props.gridApi, () => gridRef.current?.api);

  const defaultColDef = useMemo<ColDef>(
    () =>
      ({
        sortable: true,
        resizable: true,
        autoHeight: true,

        // --- Header --- //
        // headerComponent:,
        // headerComponentParams:,
        wrapHeaderText: true,
        // autoHeaderHeight: true,
        // suppressHeaderMenuButton: true,
        // suppressHeaderFilterButton: true,
        // suppressHeaderContextMenu: true,
      }) satisfies ColDef,
    [],
  );

  const cellClickedListener = useCallback((event: CellClickedEvent) => {
    console.log("cellClicked", event);
  }, []);

  return (
    <VStack style={{ height: "100%" }} data-testid="client-grid">
      <AgGridReact
        ref={gridRef}
        theme={themeSelector}
        headerHeight={27}
        groupHeaderHeight={27}
        rowHeight={33}
        defaultColDef={defaultColDef}
        rowSelection={{ mode: "multiRow", copySelectedRows: true, enableClickSelection: true }}
        cellSelection={{
          handle: { mode: "range" },
          suppressMultiRanges: true,
        }}
        onCellClicked={cellClickedListener}
        copyGroupHeadersToClipboard
        copyHeadersToClipboard
        onSortChanged={() => {}}
        suppressDragLeaveHidesColumns={true}
        {...(props as GridOptions)}
      />
    </VStack>
  );
};
